import React, { useState } from "react";
import LeadForm from "./LeadForm";
import { FaWhatsapp } from "react-icons/fa6";
import Slogan from "../images/atmospheric/slogan.png";

const Hero = () => {
    const [isDialogOpen, setDialogOpen] = useState(false);

    const openDialog = () => {
        setDialogOpen(true);
    };

    const closeDialog = () => {
        setDialogOpen(false);
    };

    return (
        <div className="relative px-4 pt-56 md:pt-64 pb-20 flex flex-col items-center justify-center dotBg" dir="rtl">

            <div className="relative z-10 text-center text-mainColor max-w-[900px] px-4">
                <div className="bg-black/50 backdrop-blur-md rounded-3xl px-8 py-10 md:px-12 md:py-14">
                    <h1 className="font-bold flex-col text-3xl md:text-5xl">
                        הופכים את העסק שלך

                        <span className="gold-text"> לסיפור הצלחה </span>
                    </h1>
                    <h2 className="font-bold my-2 text-xl text-mainColor md:text-3xl ">
                        דיגיטל פלוס
                    </h2>
                    <img src={Slogan} alt="עיצוב גרפי | כל סוגי עבודות הדפוס | הפקת פרסומות וידאו בבינה מלאכותית" className="mx-auto mt-4 max-w-[500px] w-full opacity-90" />
                </div>
            </div>

            <div className="relative z-10" data-aos="fade-down"
                data-aos-easing="ease-in-out">
                <button

                    onClick={openDialog}
                    className='m-4 my-4 mt-8  bg-gradient-to-tr btnGradient text-bgColor hover:shadow-2xl   font-bold px-6 py-2 sm:text-2xl text-xl rounded-full duration-300'
                >
                    לשיחת ייעוץ והצעת מחיר
                </button>
            </div>
            <div className="relative z-10" data-aos="fade-down"
                data-aos-easing="ease-in-out"
                data-aos-delay="400"
            >

                <button

                    className='m-4 button my-4  sm:m-8   text-mainColor hover:shadow-2xl   font-bold  sm:text-2xl text-xl rounded-full duration-300'
                    onClick={() => {
                        const phoneNumber = '972522849593';
                        const message = encodeURIComponent('היי, הגעתי מהאתר. אשמח לפרטים בנוגע לפרסום ועיצוב לעסק שלי');
                        const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`;
                        window.open(whatsappUrl, '_blank');
                    }}

                >
                    <span className="button-content justify-around items-center flex">
                        <span className="pl-2">למעבר לווצאפ</span> <FaWhatsapp size={35} />
                    </span>
                </button>

            </div>

            <div className="relative z-10"><LeadForm isOpen={isDialogOpen} onRequestClose={closeDialog} /></div>


        </div>
    );
};

export default Hero;
